<template>
  <div class="flex min-h-screen items-center justify-center px-6">
    <StateContainer
      :variant="StateVariant.ERROR"
      :illustration="
        is404 || is403
          ? IllustrationVariant.HTTP_404
          : IllustrationVariant.HTTP_500
      "
      :header="copy.header"
      :subheader="copy.subheader"
      primary-cta-label="Go to Dashboard"
      @primary-click="handleError"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useErrorStore } from '@/store/use-error-store';
import {
  StateContainer,
  StateVariant,
  IllustrationVariant,
} from '@/views/_components/state-container';

type Props = {
  error?: { statusCode?: number } | Record<string, unknown>;
};
const props = defineProps<Props>();

const errorStore = useErrorStore();
const router = useRouter();

const statusCode = computed(
  () =>
    (props.error as { statusCode?: number } | undefined)?.statusCode ??
    errorStore.statusCode,
);

const is404 = computed(() => statusCode.value === 404);

const is403 = computed(() => statusCode.value === 403);

const copy = computed(() => {
  if (is403.value) {
    return {
      header: '403 Error',
      subheader:
        "You don't have permission to view this page. Ask an Owner for access.",
    };
  }

  if (is404.value) {
    return {
      header: '404 Error',
      subheader: 'Page not found. Refresh and try again.',
    };
  }

  return {
    header: '500 Error',
    subheader: 'Internal server error. Please try again later.',
  };
});

const handleError = async () => {
  errorStore.clearError();
  await router.push('/');
};
</script>
